import { render } from "./confirm-dialog.vue?vue&type=template&id=38860e77&lang=pug"
import script from "./confirm-dialog.vue?vue&type=script&lang=js"
export * from "./confirm-dialog.vue?vue&type=script&lang=js"

import "./confirm-dialog.vue?vue&type=style&index=0&id=38860e77&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__